// src/App.tsx — Yak ops console shell (AI-first pivot)
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { AuthProvider } from './components/auth/AuthProvider'
import { RouteGuard, SuperAdminRoute } from './components/RouteGuard'
import { SignInForm } from './components/auth/SignInForm'
import AuthLayout from './components/layout/AuthLayout'
import {
  YakCustomerHealth,
  YakKbUpdates,
  YakProspects,
} from './components/admin/YakViews'
import { TicketListPage } from './components/tickets/TicketListPage'
import { TicketDetailPage } from './components/tickets/TicketDetailPage'
import { KnowledgeBase } from './components/kb/KnowledgeBase'
import { KbDocumentDetail } from './components/kb/KbDocumentDetail'
import { KbVersionView } from './components/kb/KbVersionView'
import { SuperAdminPanel } from './components/super-admin/SuperAdminPanel'
import { SettingsPage } from './components/pages/SettingsPage'
import { Layout } from './components/Layout'

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route
            path="/login"
            element={
              <AuthLayout>
                <SignInForm />
              </AuthLayout>
            }
          />

          {/* Protected routes with layout. Every authenticated org user is
              a reviewer — RLS scopes all yak_ data to their organization. */}
          <Route
            path="/"
            element={
              <RouteGuard>
                <Layout />
              </RouteGuard>
            }
          >
            {/* Ticket desk (Epic 4). My tickets is the home surface; the
                three views nest under /tickets. Static routes rank above the
                dynamic :id segment (react-router 6), so no collision. The
                /tickets/:id stub resolves Story 3.7's assignment-email deep
                links now; Story 4.2 replaces the component in place. */}
            <Route index element={<TicketListPage view="mine" />} />
            <Route
              path="tickets/open"
              element={<TicketListPage view="all_open" />}
            />
            <Route
              path="tickets/closed"
              element={<TicketListPage view="closed" />}
            />
            <Route path="tickets/:id" element={<TicketDetailPage />} />

            <Route path="health" element={<YakCustomerHealth />} />

            {/* Knowledge Base (new corpus). Routed detail + deep-linkable
                read-only version view (/kb/:documentId/versions/:versionId) that
                Epic 4's ticket screen links to for pinned sources. /kb-updates
                below is read-only history now that its intake feeder is retired
                (Story 4.10) — Epic 2's /kb is the live workflow. */}
            <Route path="kb" element={<KnowledgeBase />} />
            <Route path="kb/:documentId" element={<KbDocumentDetail />} />
            <Route
              path="kb/:documentId/versions/:versionId"
              element={<KbVersionView />}
            />
            <Route path="kb-updates" element={<YakKbUpdates />} />

            {/* Prospects: ScriptYak-internal pipeline (super_admin RLS) */}
            <Route
              path="prospects"
              element={
                <SuperAdminRoute>
                  <YakProspects />
                </SuperAdminRoute>
              }
            />

            <Route path="settings/*" element={<SettingsPage />} />

            {/* Super Admin routes */}
            <Route
              path="super-admin/*"
              element={
                <SuperAdminRoute>
                  <SuperAdminPanel />
                </SuperAdminRoute>
              }
            />
          </Route>

          {/* Catch all - back to the ticket desk */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App
